import axios from 'src/api';
import { NotificationManager } from 'react-notifications';
import {
  _getAllLogs,
  _getCustomers,
  _filterLogs,
  getSelfRequest,
  getAdminLogsRequest,
  getAdminIssuerLogsRequest,
  getAdminIssuerStaffLogsRequest,
  getSelfIssuerLogRequest
} from 'src/api/LogsRequest';
import {
  GETISSUERS_SUCCESS,
  GETLOG_SUCCESS,
  GET_ADMIN_LOG,
  GET_ISSUER_ADMIN_LOG
} from '../types';
import { checkRequestError } from '.';
import { getSelfAction } from './StaffActions';

export const getSelf = (filterObj, profile) => {
  return async (dispatch) => {
    try {
      const { data } =
        profile?.super == 1
          ? await getSelfRequest(filterObj)
          : await getSelfIssuerLogRequest(filterObj);

      checkRequestError(data);

      dispatch({ type: GETLOG_SUCCESS, payload: data.content.data?.all || [] });
      return 1;
    } catch (error) {
      return -1;
    }
  };
};

export const getAdminLogsAction = (filterObj, profile) => {
  return async (dispatch) => {
    try {
      const { data } =
        profile?.super == 1
          ? await getAdminLogsRequest(filterObj)
          : await getAdminIssuerStaffLogsRequest(filterObj);
      checkRequestError(data);

      dispatch({ type: GET_ADMIN_LOG, payload: data.content.data?.all || [] });
      return 1;
    } catch (error) {
      return -1;
    }
  };
};

export const getAdminIssuerLogsAction = (filterObj, profile) => {
  return async (dispatch) => {
    try {
      const { data } = await getAdminIssuerLogsRequest(filterObj);

      checkRequestError(data);

      dispatch({
        type: GET_ISSUER_ADMIN_LOG,
        payload: data.content.data?.all || []
      });
      return 1;
    } catch (error) {
      return -1;
    }
  };
};

export const filterLogs = (obj) => {
  return async (dispatch) => {
    try {
      const { issuerID, userID, fromDate, toDate } = obj;
      const reqObj = {
        data: {
          issuerID,
          userID,
          fromDate,
          toDate
        }
      };

      const { data } = await _filterLogs(reqObj);

      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch({ type: GETLOG_SUCCESS, payload: data.content });
        // NotificationManager.success(data.success.message, 'Success');
        return 1;
      }
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const getIssuers = () => {
  return async (dispatch) => {
    try {
      const { data } = await _getCustomers();

      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch({ type: GETISSUERS_SUCCESS, payload: data.content });
        // NotificationManager.success(data.success.message, 'Success');
        return 1;
      }
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};
